/*@flow*/
import GetGoogleFormButtons from './queries/GetGoogleFormButtons';
import * as I from 'immutable';
import useCachedQuery from 'lib/useCachedQuery';
import type { GoogleButton } from './types';

export default (): {|data: Array<GoogleButton>, error: any, loading: any|} => {
  const { data, error, loading } = useCachedQuery(GetGoogleFormButtons, {});
  const path = ['me', 'company', 'googleFormButtons'];
  let googleButtons: GoogleButton[] = I.getIn(data, path, []);
  return { data: googleButtons, error, loading };
};
